import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
  RouteRecordRaw,
  NavigationGuardNext,
} from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verificando sesión',
        },
      },
    ],
  },
  // app routes
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'app-home',
        // component: () => import('../views/app/home.vue'),
        meta: {
          title: 'Inicio',
        },
        redirect: { path: '/app/dgenc' },
      },
      // dgenc route
      {
        path: 'dgenc',
        name: 'dgenc',
        component: () => import('../views/app/dgenc.vue'),
        meta: {
          title: 'DGENC',
          requiresAuth: true,
        },
      },
    ],
  },
  // regex
  {
    path: '/regex',
    name: 'regex',
    component: () => import('../views/regex.vue'),
    meta: {
      title: 'Regex',
    },
  },
  // base64 route
  {
    path: '/base64',
    name: 'base64',
    component: () => import('../views/base64.vue'),
    meta: {
      title: 'Encode Decode Base64',
    },
  },
  // md5 route
  {
    path: '/md5',
    name: 'md5',
    component: () => import('../views/md5.vue'),
    meta: {
      title: 'MD5',
    },
  },
  // uuidv4 route
  {
    path: '/uuidv4',
    name: 'uuidv4',
    component: () => import('../views/uuidv4.vue'),
    meta: {
      title: 'UUIDv4',
    },
  },
  // timestamp
  {
    path: '/timestamp',
    name: 'timestamp',
    component: () => import('../views/timestamp.vue'),
    meta: {
      title: 'Timestamp',
    },
  },
  // block ads chrome extension route
  {
    path: '/block-ads-chrome-extension',
    name: 'block-ads-chrome-extension',
    component: () => import('../views/block-ads-chrome-extension.vue'),
    meta: {
      title: 'Block Ads Chrome Extension',
    },
  },
  // lesson generator route
  {
    path: '/lesson-generator',
    name: 'lesson-generator',
    component: () => import('../views/lesson-generator.vue'),
    meta: {
      title: 'Lesson Generator',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // siempre scrollea al top
    return { top: 0, left: 0 };
  },
});

router.afterEach(() => {
  const app = document.querySelector('#app');
  if (!app) return;

  app.classList.add('page-transition');

  setTimeout(() => {
    app.classList.remove('page-transition');
  }, 300); // duración suave
});

router.beforeEach((
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} | digi systems`;
  }

  if (to.matched.some((record: RouteRecordRaw) => record.meta?.requiresAuth ?? false)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem('token')) {
      const { VUE_APP_DG_USERS_APP } = process.env;
      const url = `${VUE_APP_DG_USERS_APP}/auth/login?app=utils`;
      console.log('url', url);
      window.location.href = url;
    } else {
      next();
    }
  }
  next();
});

export default router;
